module.exports = __webpack_public_path__ + "img/dots_lbp1.31c6f228.png";